module.exports = __webpack_public_path__ + "d4158bf1d074c452f8449fb02fc7ab72.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/maxiventas.png
// module id = 608
// module chunks = 0